import React, { useState, useEffect } from 'react';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import axios from 'axios';
import api from '../common/api';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
  
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
  
export default function FreshDeskTicket({data, onTicketConfirmed}) {
  const [saving, setSaving] = useState(false);
  const [open, setOpen] = useState(false);
  const [ticket, setTicket] = useState({});
  const [snackBar, setSnackBar] = useState({})
  useEffect(() => {
    ticket.external_id = data.external_id;
    ticket.subject = data.subject;
    ticket.plate = data.plate;
    ticket.contact_email = data.contact_email;
    ticket.contact_name = data.contact_name;
    ticket.type = data.type;
    setTicket(ticket)
  },);

  const handleSubmit = async () => {
    setSaving(true);
    var formData = new FormData();
    formData.set("ticket[reason]", ticket.subject);
    formData.set("ticket[description]", ticket.body);
    formData.set("ticket[contact_email]", ticket.contact_email);
    formData.set("ticket[contact_name]", ticket.contact_name);
    formData.set("ticket[external_id]", ticket.external_id);
    formData.set("ticket[plate]", ticket.plate);
    formData.set("ticket[freshdesk_type]", ticket.type);
    let self = this
    const token = localStorage.getItem('userToken')
    await axios.post(api.freshdesk().post(),
        formData,
        {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
       )
      .then((response)=> {
        var ticket = response.data.ticket
        onTicketConfirmed(ticket.id);
        setOpen(false)
        setSaving(false);
      })
      .catch(function (error) {
        snackBar.open = true
        snackBar.message = 'No se pudo crear el ticket en freshdesk'
        snackBar.severity = 'warning'
        setSnackBar(snackBar)
        setTicket({ ...ticket, id: ''})
        setSaving(false);
    })

  }
  return (
    <div className='d-inline-block'>
        <AddIcon fontSize="small" className="ml-1"  onClick={(e) => {setOpen(true)}} />
        <Dialog fullScreen open={open} onClose={(e) => setOpen(false)}  TransitionComponent={Transition}>
            <AppBar className="mt-2 position-relative" >
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={(e) => setOpen(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" style={{color:"white"}}>
                        Crear ticket
                    </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent style={{overflow: 'hidden'}}>
                <Snackbar open={snackBar.open} onClose={(value) =>
                            setSnackBar({ ...snackBar, open: false })
                            }
                >
                    <Alert onClose={(value) =>
                            setSnackBar({ ...snackBar, open: false })
                        }
                        severity={snackBar.severity}>
                        {snackBar.message}
                    </Alert>
                </Snackbar>

                <TextField
                    id="subject"
                    disabled	
                    name="subject"
                    margin="normal"
                    InputProps={{
                        startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{minWidth: 50}}>Asunto</Typography></InputAdornment>,
                    }}
                    className="mr-2 mt-0"
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={ticket.subject}
                    inputProps={{
                        style:{fontSize: '0.75rem', width: 300}
                    }}
                />
                <TextField
                    id="plate"
                    disabled	
                    name="plate"
                    margin="normal"
                    InputProps={{
                        startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{minWidth: 100}}>Patente </Typography></InputAdornment>,
                    }}
                    className="mr-2 mt-0"
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={ticket.plate}
                    inputProps={{
                        style:{fontSize: '0.75rem', width: 100}
                    }}
                />

                <TextareaAutosize
                    id="body"
                    name="body"
                    margin="normal"
                    InputProps={{
                        startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{minWidth: 50}}>Cuerpo </Typography></InputAdornment>,
                    }}
                    minRows={5}
                    placeholder="Agregue descripción del ticket"
                    className="mr-2 mt-0"
                    InputLabelProps={{
                        shrink: true
                    }}
                    onChange={(value) =>
                        setTicket({ ...ticket, body: value.target.value })
                    }
                    value={ticket.body}
                    style={{ width: '100%', fontSize: '0.75rem'}}
                />                
                <TextField
                    id="contact_name"
                    disabled	
                    name="contact_name"
                    margin="normal"
                    InputProps={{
                        startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{minWidth: 100}}>Contacto</Typography></InputAdornment>,
                    }}
                    className="mr-2 mt-0"
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={ticket.contact_name}
                    inputProps={{
                        style:{fontSize: '0.75rem', width: 200}
                    }}
                />
                <TextField
                    id="contact_email"
                    disabled	
                    name="contact_email"
                    margin="normal"
                    InputProps={{
                        startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{minWidth: 100}}>Mail Contacto </Typography></InputAdornment>,
                    }}
                    className="mr-2 mt-0"
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={ticket.contact_email}
                    inputProps={{
                        style:{fontSize: '0.75rem', width: 200}
                    }}
                />                
            </DialogContent>
            <DialogActions>
            <Button onClick={(e) => setOpen(false)} color="secondary" variant="contained">
                Cancelar
            </Button>
            <Button onClick={(e) => handleSubmit()} color="primary" autoFocus variant="contained" disabled={saving}>
                Crear
            </Button>
            </DialogActions>            
        </Dialog>    
    </div>
  );
}